// S :::: 비디오 이미지 불러오기 :::: S
import VideoImage01 from "../assets/images/shuffle/shuffle-video01.png";
import VideoImage02 from "../assets/images/shuffle/shuffle-video02.png";
// E :::: 비디오 이미지 불러오기 :::: E

export const videoList = [
  {
    category: "하우스",
    title: "하우스 비기너",
    desc: "화 8:00 PM",
    videoId: "0bt9sNQuBss",
    thumbImg: VideoImage01,
    link: "https://www.youtube.com/watch?v=0bt9sNQuBss",
  },
  {
    category: "셔플",
    title: "셔플&풋워크 LV.4",
    desc: "DA FONK",
    videoId: "M6dP8ISp6G8",
    thumbImg: VideoImage02,
    link: "https://www.youtube.com/watch?v=M6dP8ISp6G8",
  },
  // {
  //   category: "하우스",
  //   title: "셔플&풋워크 LV.2",
  //   desc: "Aespa - Drama",
  //   videoId: "rEmlS18xtRg",
  //   thumbImg: VideoImage01,
  //   link: "https://www.youtube.com/watch?v=0bt9sNQuBss",
  // },
  // {
  //   category: "팝업클래스",
  //   title: "팝업클래스 입니다",
  //   desc: "Aespa - Drama",
  //   videoId: "cyq5-StPISU",
  //   thumbImg: VideoImage01,
  //   link: "https://www.youtube.com/watch?v=M6dP8ISp6G8",
  // },
  // {
  //   category: "하드트레이닝",
  //   title: "하드트레이닝 레슨",
  //   desc: "Aespa - Drama",
  //   videoId: "HafuyqrOs1w",
  //   thumbImg: VideoImage01,
  //   link: "https://www.youtube.com/watch?v=0bt9sNQuBss",
  // },
  // {
  //   category: "KPOP",
  //   title: "KPOP",
  //   desc: "Aespa - Drama",
  //   videoId: "EO2CbzmWK_A",
  //   thumbImg: VideoImage01,
  //   link: "https://www.youtube.com/watch?v=M6dP8ISp6G8",
  // },
];

export const videoCategoryListWrap = [
  {
    category: "셔플",
  },
  {
    category: "하우스",
  },
  // {
  //   category: "팝업클래스",
  // },
  // {
  //   category: "하드트레이닝",
  // },
  // {
  //   category: "KPOP",
  // },
];
